import React, { useEffect, useState } from "react";
import { formatTotalHours, getAllMonths, getAllYears, getFieldData, getMonthLastDay, getMonthName, getTotalDays, getTotalHours } from "../../../services/appService";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { getTimeLogDuration, getTimeLogs, getTimeLogsLoading, loadTimeLogDuration, loadTimeLogs } from "../../store/timeLog";
import { deleteRecruiterTimeLogInvDoc, getRecTimeLogInvDocDeleteStatus, getTimeLogInvoice, loadTimeLogInvoice } from "../../store/timeLogInvoice";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import AddNewTimeLog from "../../../components/OMCRegistry/AddNewTimeLog";
import InvoiceReview from "../../../components/OMCRegistry/InvoiceReview";
import AddEditNotes from "../../../components/OMCRegistry/AddEditNotes";
import CandidatePay from "../../../components/OMCRegistry/CandidatePay";
import useDocDownload from "../../hooks/useDocDownload";

export default function Recruiter(props) {
    const { candidate, ptype, entType, wfTask, allRates } = props;

    const [timeLogs, setTimeLogs] = useState([]);
    const [timeLogInvoices, setTimeLogInvoices] = useState([]);
    const [invRevShowHide, setInvRevShowHide] = useState(false);
    const [timeLogShowHide, setTimeLogShowHide] = useState(false);
    const [noteShowHide, setNoteShowHide] = useState(false);
    const [payShowHide, setPayShowHide] = useState(false);
    const [invType, setInvType] = useState("recruiter");
    const [timeLogObj, setTimeLogObj] = useState("");
    const [filterYear, setFilterYear] = useState("");
    const [filterMonth, setFilterMonth] = useState("");
    const [selectedYear, setSelectedYear] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [notesType, setNotesType] = useState("TimeLogRecruiter");
    const [projectStartDate, setProjectStartDate] = useState("");
    const [projectStDt, setProjectStDt] = useState("");
    const [currentStDt, setCurrentStDt] = useState("");

    const [lastLoadedId, setLastLoadedId] = useState(null);
    const timeLogsSelector = useSelector(getTimeLogs);
    const isTimeLogsLoading = useSelector(getTimeLogsLoading);
    const timeLogsInvoiceSelector = useSelector(getTimeLogInvoice);
    const timeLogDurationSelector = useSelector(getTimeLogDuration);
    const timeLogInvDocDeleteStatusSelector = useSelector(getRecTimeLogInvDocDeleteStatus);

    const [handleDownloadFile] = useDocDownload();

    const dispatch = useDispatch();
    const sortTimeLogsByLatestPeriod = (logs = []) =>
        [...logs].sort((a, b) => {
            const yearDiff = (parseInt(b?.year, 10) || 0) - (parseInt(a?.year, 10) || 0);
            if (yearDiff !== 0) return yearDiff;

            return (parseInt(b?.month, 10) || 0) - (parseInt(a?.month, 10) || 0);
        });

    useEffect(() => {
        if (candidate?.id) {
            dispatch(loadTimeLogs(candidate.id));
            dispatch(loadTimeLogInvoice(candidate.id));
            dispatch(loadTimeLogDuration(candidate.id));
            setSelectedYear("");
            setSelectedMonth("");
            setFilterYear("");
            setFilterMonth("");
            setLastLoadedId(candidate.id);
        }
    }, [candidate?.id]);

    useEffect(() => {
        if (timeLogsInvoiceSelector.length > 0) {
            const subcontractorInvoices = timeLogsInvoiceSelector.filter(x => x.invoiceType === invType);
            setTimeLogInvoices(subcontractorInvoices)
        }

        if (timeLogDurationSelector?.startDate) {
            const startDate = new Date(timeLogDurationSelector.startDate);
            startDate.setDate(startDate.getDate() + 1); // add 1 day
            const result = startDate.toISOString().substring(0, 10);
            setProjectStDt(startDate);
            setCurrentStDt(timeLogDurationSelector.projectStartedDate);
        }

    }, [timeLogsInvoiceSelector, timeLogDurationSelector]);

    useEffect(() => {
        let filterTimeLogs = [...timeLogsSelector];
        if (filterYear > 0)
            filterTimeLogs = filterTimeLogs.filter(x => x.year === parseInt(filterYear));

        if (filterMonth > 0)
            filterTimeLogs = filterTimeLogs.filter(x => x.month === parseInt(filterMonth));

        setTimeLogs(sortTimeLogsByLatestPeriod(filterTimeLogs));

    }, [timeLogsSelector, filterMonth, filterYear]);

    const handleApplyFilter = () => {
        setFilterYear(selectedYear);
        setFilterMonth(selectedMonth);
    };

    const handleResetFilter = () => {
        setSelectedYear("");
        setSelectedMonth("");
        setFilterYear("");
        setFilterMonth("");
    };

    const years = getAllYears();
    const months = getAllMonths();
    const perfData = candidate?.performerData;
    const recruiterRate = candidate.rates?.recruiterRate;
    const recruiterDate = candidate.rates?.recruiterEffectiveDate;

    const getMonthlyPeriod = (obj) => {
        if (!obj?.workingHrs) return "";
        const wt = JSON.parse(obj.workingHrs);
        const sortWt = wt.sort((a, b) => new Date(a.start) - new Date(b.start));
        if (sortWt.length === 0) return "";

        const first = sortWt[0];
        const last = sortWt[sortWt.length - 1];
        const lastDate = last.type === "m" ? getMonthLastDay(last.start) : last.start;

        return (
            <span className="wf-period-range">
                <span className="wf-period-range-line">
                    <span className="wf-period-range-tag">From</span>
                    <Moment format="MM/DD/YYYY">{first.start}</Moment>
                </span>
                <span className="wf-period-range-line">
                    <span className="wf-period-range-tag">To</span>
                    <Moment format="MM/DD/YYYY">{lastDate}</Moment>
                </span>
            </span>
        );
    };

    const getInvoiceStatus = (item) => {
        const tmLogs = timeLogInvoices.filter(
            (x) => x.timeLogId === item.id
                && x.status !== null
        );
        if (tmLogs.length === 0) {
            return (
                <button
                    type="button"
                    className="wf-status-pill wf-status-pending"
                    style={{ cursor: "pointer", outline: "none" }}
                    onClick={() => handleInvRevShowHide(item)}
                >
                    Review
                </button>
            );
        }

        return (
            <div className="wf-status-stack">
                {tmLogs.map((inv, index) => (
                    <React.Fragment key={inv.id || index}>
                        <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                            <button
                                type="button"
                                className="wf-status-pill wf-status-reviewed"
                                style={{ cursor: "pointer", outline: "none" }}
                                onClick={() => handleInvRevShowHide(item)}
                            >
                                <i className="fa fa-eye" aria-hidden="true"></i> Reviewed
                            </button>
                            {inv.status === true && (
                                <i className="fa fa-check-circle" style={{ color: "#10b981", fontSize: "16px" }} aria-hidden="true" title="Approved" />
                            )}
                            {inv.status === false && (
                                <i className="fa fa-times-circle" style={{ color: "#ef4444", fontSize: "16px" }} aria-hidden="true" title="Rejected" />
                            )}
                        </div>
                        {inv.reviewDateTime && (
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                                
                                <span style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    color: "#475569",
                                    lineHeight: 1
                                }}>
                                    <Moment format="MMM Do YYYY, h:mm a">{inv.reviewDateTime}</Moment>
                                </span>
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    const getRecruiterInvoice = (item) => {
        const tmLogs = timeLogInvoices
            .filter(
                (x) =>
                    x.timeLogId === item.id &&
                    x.invDoc !== null
            );

        if (tmLogs.length === 0) return <span style={{ color: "#94a3b8" }}>—</span>;

        return (
            <div className="wf-status-stack">
                {tmLogs.map((inv, index) => (
                    <React.Fragment key={inv.id || index}>
                        <span style={{ fontWeight: 600, fontSize: "13px", color: "#334155" }}>
                            Inv: {inv.invoiceNumber}
                        </span>
                        {inv.invDoc && (
                            <div className="wf-doc-row">
                                <button
                                    type="button"
                                    className="wf-doc-link"
                                    onClick={() => handleDownloadFile(inv.invDoc)}
                                    title={inv.invDoc.documentName}
                                >
                                    <i className="fa fa-file-pdf-o" style={{ color: "#ef4444", marginRight: "4px" }} />
                                    {inv.invDoc.documentName.length > 15 ? inv.invDoc.documentName.substring(0, 15) + "..." : inv.invDoc.documentName}
                                </button>
                            </div>
                        )}
                        {inv.notes === "delete" && (
                            <div className="wf-doc-row wf-doc-row-delete" style={{ marginTop: "4px" }}>
                                <button
                                    type="button"
                                    className="wf-doc-link wf-btn-delete-regenerate"
                                    title="Delete Invoice Document"
                                    onClick={() => handleDeleteInvoiceDoc(inv.id)}
                                >
                                    <i className="fa fa-trash-o" /> Delete/Regenerate
                                </button>
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    const handleDeleteInvoiceDoc = async (id) => {
        const result = await getConfirmAlert("", "Are you sure you want to delete this document?", "error");
        if (result.isConfirmed) {
            dispatch(deleteRecruiterTimeLogInvDoc(id))
        }
    }

    useEffect(() => {
        if (timeLogInvDocDeleteStatusSelector) {
            getAlert("", "Successfully Deleted.", "success");
            if (candidate?.id)
                dispatch(loadTimeLogInvoice(candidate.id));
        }
    }, [timeLogInvDocDeleteStatusSelector])

    const getApplicableRateDetails = (item) => {
        const itemYear = parseInt(item?.year, 10);
        const itemMonth = parseInt(item?.month, 10);
        const rateField = "recruiterRate"
        const dateField = "recruiterEffectiveDate";
        const matchedRate = Array.isArray(allRates)
            ? allRates.reduce((best, rate, index) => {
                if (!itemYear || !itemMonth) return best;

                const effMs = new Date(rate?.[dateField]).getTime();
                if (Number.isNaN(effMs)) return best;

                const effDt = new Date(effMs);
                const effYear = effDt.getFullYear();
                const effMonth = effDt.getMonth() + 1;
                const isApplicable =
                    effYear < itemYear ||
                    (effYear === itemYear && effMonth <= itemMonth);

                if (!isApplicable) return best;
                if (!best) return { rate, index, effMs };

                if (effMs > best.effMs) return { rate, index, effMs };
                if (effMs < best.effMs) return best;

                const addedMs = new Date(rate?.addedDateTime).getTime();
                const bestAddedMs = new Date(best.rate?.addedDateTime).getTime();
                const safeAddedMs = Number.isNaN(addedMs) ? -Infinity : addedMs;
                const safeBestAddedMs = Number.isNaN(bestAddedMs) ? -Infinity : bestAddedMs;

                if (safeAddedMs > safeBestAddedMs) return { rate, index, effMs };
                if (safeAddedMs < safeBestAddedMs) return best;

                const idNum = Number(rate?.id);
                const bestIdNum = Number(best.rate?.id);
                const safeIdNum = Number.isFinite(idNum) ? idNum : -Infinity;
                const safeBestIdNum = Number.isFinite(bestIdNum) ? bestIdNum : -Infinity;

                if (safeIdNum > safeBestIdNum) return { rate, index, effMs };
                if (safeIdNum < safeBestIdNum) return best;

                return index > best.index ? { rate, index, effMs } : best;
            }, null)?.rate
            : null;

        const fallbackRate = 0;//parseFloat(recruiterRate || 0);
        const rateValue =
            matchedRate?.[rateField] !== null &&
                matchedRate?.[rateField] !== undefined &&
                matchedRate?.[rateField] !== ""
                ? parseFloat(matchedRate[rateField])
                : fallbackRate;

        const effectiveDate = matchedRate?.[dateField] || "";
        return {
            rate: rateValue,
            effectiveDate,
        };
    };

    const getInvoiceAmount = (item) => {
        const totHrs = getTotalHours(item?.workingHrs || 0);
        const { rate: applicableRate } = getApplicableRateDetails(item);
        let invAmt = totHrs * applicableRate;

        // If not W2, return straight amount
        if (entType !== "W2 Basis") {
            return parseFloat(invAmt || 0).toFixed(2);
        }

        // W2 → add tax
        const taxRate = (getFieldData(perfData, "candidateonboardingform", "Tax") || 0) / 100;
        invAmt = invAmt + invAmt * taxRate;

        return parseFloat(invAmt || 0).toFixed(2);
    };

    const getFinalAmout = (obj) => {
        let fAmt = parseFloat(getInvoiceAmount(obj));
        const invItems = timeLogInvoices.filter(
            (x) => x.timeLogId === obj.id
        );
        if (invItems.length > 0) {
            const item = invItems[0];
            if (item?.adjustmentMinues > 0)
                fAmt -= item.adjustmentMinues;
            if (item?.adjustmentPlus > 0)
                fAmt += item.adjustmentPlus;
            if (item?.adpDeduction > 0)
                fAmt -= item.adpDeduction;
            return parseFloat(fAmt || 0).toFixed(2);
        } else {
            return parseFloat(fAmt || 0).toFixed(2);
        }
    };

    const getPaymentStatus = (item) => {
        const tmLogs = timeLogInvoices.filter(
            (x) =>
                x.timeLogId === item.id &&
                x.paymentMode !== null
        );
        if (tmLogs.length === 0) {
            return (
                <button
                    type="button"
                    className="wf-status-pill wf-status-rejected"
                    style={{ cursor: "pointer", outline: "none" }}
                    onClick={() => handlePayShowHide(item)}
                >
                    To Pay
                </button>
            );
        }
        console.log(tmLogs, "tmLogs")
        return (
            <div className="wf-status-stack">
                {tmLogs.map((pay, index) => (
                    <React.Fragment key={pay.id || index}>
                        <button
                            type="button"
                            className="wf-status-pill wf-status-approved"
                            style={{ cursor: "pointer", outline: "none" }}
                            onClick={() => handlePayShowHide(item)}
                        >
                            Paid By IPCS (${parseFloat(pay.paidAmount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})
                        </button>
                        {pay.paymentDate && (
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                                
                                <span style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    color: "#475569",
                                    lineHeight: 1
                                }}>
                                    <Moment format="MMM Do YYYY">{pay.paymentDate}</Moment>
                                </span>
                            </div>
                        )}
                        {pay?.docList && pay.docList.length > 0 && (
                            <ul className="wf-doc-list" style={{ marginTop: "4px" }}>
                                {pay.docList.map((doc, idx) => (
                                    <li key={idx} className="wf-doc-row">
                                        <button
                                            type="button"
                                            className="wf-doc-link"
                                            onClick={() => handleDownloadFile(doc)}
                                            title={doc.documentName}
                                        >
                                            <i className="fa fa-paperclip" /> {doc.documentName.length > 15 ? doc.documentName.substring(0, 15) + "..." : doc.documentName}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    }

    const getDueAmountStatus = (item) => {
        const tmLogs = timeLogInvoices
            .filter(
                (x) =>
                    x.timeLogId === item.id &&
                    x.paidAmount !== null
            );
        if (tmLogs.length === 0) return "";

        return <>
            {tmLogs.map((inv) => parseFloat(getFinalAmout(item) - inv.paidAmount).toFixed(2))}
        </>

    }

    const handleInvRevShowHide = (obj) => {
        if (obj === "save") {
            setInvRevShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogInvoice(candidate?.id))
        }
        else {
            setInvRevShowHide(!invRevShowHide);
            setTimeLogObj(obj);
        }
    };

    const handleShowHide = async (obj) => {
        if (obj === "save") {
            setTimeLogShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogs(candidate.id));
        } else {
            setTimeLogShowHide(!timeLogShowHide);
            setTimeLogObj(obj);
        }
    };



    const handleNoteShowHide = (obj) => {
        setNoteShowHide(!noteShowHide);
        setTimeLogObj(obj);
    };

    const handlePayShowHide = async (obj) => {
        if (obj === "save") {
            setPayShowHide(false);
            setTimeLogObj("");
            if (candidate?.id)
                dispatch(loadTimeLogInvoice(candidate?.id))
        } else {
            if (obj === "close") {
                setPayShowHide(false);
                setTimeLogObj("");
            } else {
                const chkInvoice = timeLogInvoices.filter(
                    (x) =>
                        x.timeLogId === obj.id && x.invDoc !== null
                );
                // console.log(chkInvoice, entType, "chkInvoice")
                // if (chkInvoice.length > 0 || entType !== "C2C Basis") {
                if (chkInvoice.length > 0) {
                    setPayShowHide(!payShowHide);
                    setTimeLogObj(obj);
                } else {
                    getAlert("", "Invoice not generated", "error");
                }
            }
        }
    };

    // Computations for Stats Header
    const totalMinutes = timeLogs.reduce((sum, log) => {
        if (!log?.workingHrs) return sum;
        let wt;
        try {
            wt = JSON.parse(log.workingHrs);
        } catch (e) {
            return sum;
        }
        if (!Array.isArray(wt)) return sum;
        let logMinutes = 0;
        wt.filter((x) => x.title !== null).forEach((t) => {
            const parts = t.title.toString().split(".");
            const hours = parseInt(parts[0], 10) || 0;
            const minutes = parseInt(parts[1], 10) || 0;
            logMinutes += hours * 60 + minutes;
        });
        return sum + logMinutes;
    }, 0);

    const statHours = Math.floor(totalMinutes / 60);
    const statMinutes = totalMinutes % 60;
    const totalHoursStr = `${statHours}h ${statMinutes}m`;

    const totalDaysVal = timeLogs.reduce((sum, log) => Number(sum) + Number(getTotalDays(log?.workingHrs) || 0), 0);

    const reviewedLogsCount = timeLogs.filter(log =>
        timeLogInvoices.some(inv => inv.timeLogId === log.id && inv.status !== null)
    ).length;

    const paidLogsCount = timeLogs.filter(log =>
        timeLogInvoices.some(inv => inv.timeLogId === log.id && (inv.paymentMode !== null || (inv.paidAmount !== null && parseFloat(inv.paidAmount) > 0)))
    ).length;

    const reviewedPaidStr = `${reviewedLogsCount} / ${paidLogsCount}`;

    return <React.Fragment>

        <div className="wf-controls-card">
            <div className="wf-controls-left">
                <div className="wf-select-wrapper">
                    <i className="fa fa-calendar wf-select-icon"></i>
                    <select
                        name="filterYear"
                        id="filterYear"
                        className="wf-control-select"
                        aria-label="Select Year"
                        value={selectedYear}
                        onChange={({ currentTarget }) => setSelectedYear(currentTarget.value)}
                    >
                        <option value="">Year</option>
                        {years.map((y) => (
                            <option key={y.name} value={y.name}>{y.name}</option>
                        ))}
                    </select>
                </div>
                <div className="wf-select-wrapper">
                    <i className="fa fa-filter wf-select-icon"></i>
                    <select
                        name="filterMonth"
                        id="filterMonth"
                        className="wf-control-select"
                        aria-label="Select Month"
                        value={selectedMonth}
                        onChange={({ currentTarget }) => setSelectedMonth(currentTarget.value)}
                    >
                        <option value="">Month</option>
                        {months.map((m) => (
                            <option key={m.id} value={m.id}>{m.name}</option>
                        ))}
                    </select>
                </div>
                <button
                    type="button"
                    onClick={handleApplyFilter}
                    className="wf-btn-apply"
                >
                    <i className="fa fa-search"></i> Apply Filter
                </button>
                <button
                    type="button"
                    onClick={handleResetFilter}
                    className="wf-btn-reset"
                >
                    <i className="fa fa-refresh"></i> Reset
                </button>
            </div>
        </div>

        <div className="wf-stats-row">
            <div className="wf-stat-card">
                <div className="wf-stat-icon-wrap">
                    <i className="fa fa-file-text-o"></i>
                </div>
                <div className="wf-stat-text">
                    <span className="wf-stat-label">Time Logs</span>
                    <div className="wf-stat-value">{timeLogs.length}</div>
                </div>
                
            </div>
            <div className="wf-stat-card">
                <div className="wf-stat-icon-wrap">
                    <i className="fa fa-clock-o"></i>
                </div>
                <div className="wf-stat-text">
                    <span className="wf-stat-label">Total Hours</span>
                    <div className="wf-stat-value">{totalHoursStr}</div>
                </div>
                
            </div>
            <div className="wf-stat-card">
                <div className="wf-stat-icon-wrap">
                    <i className="fa fa-calendar-check-o"></i>
                </div>
                <div className="wf-stat-text">
                    <span className="wf-stat-label">Total Days</span>
                    <div className="wf-stat-value">{totalDaysVal}</div>
                </div>
                
            </div>
            <div className="wf-stat-card">
                <div className="wf-stat-icon-wrap">
                    <i className="fa fa-credit-card"></i>
                </div>
                <div className="wf-stat-text">
                    <span className="wf-stat-label">Reviewed / Paid</span>
                    <div className="wf-stat-value">{reviewedPaidStr}</div>
                </div>
                
            </div>
        </div>

        <div className="table-responsive mt-2 wf-table-scroll">
            <table className="table align-items-center table-flush table-striped wf-table recruiter-invoices-table">
                <thead className="wf-thead">
                    <tr>
                        <th>
                            Month
                            <span className="wf-thead-subtext">Year</span>
                        </th>
                        <th>
                            Period
                            <span className="wf-thead-subtext">Time Logged</span>
                        </th>
                        <th>
                            Hours
                            <span className="wf-thead-subtext">Days</span>
                        </th>
                        <th>
                            Approved
                            <span className="wf-thead-subtext">Timesheets</span>
                        </th>
                        <th>Status</th>
                        <th>Rate/$Hr</th>
                        <th>
                            Invoice
                            <span className="wf-thead-subtext">Amount ($)</span>
                        </th>
                        <th>Invoice</th>
                        <th>Notes</th>
                        <th>
                            Final Pay
                            <span className="wf-thead-subtext">Amount ($)</span>
                        </th>
                        <th>Payment</th>
                    </tr>
                </thead>
                <tbody>
                    {(isTimeLogsLoading || lastLoadedId !== candidate?.id) ? (
                        <tr>
                            <td colSpan={11} style={{ textAlign: "center", padding: "40px 20px", color: "#64748b" }}>
                                <div style={{ fontSize: "28px", marginBottom: "10px", color: "#2563eb" }}>
                                    <i className="fa fa-spinner fa-spin"></i>
                                </div>
                                <div style={{ fontWeight: 600, fontSize: "15px" }}>Loading Time Logs...</div>
                                <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: "4px" }}>Please wait while we fetch the latest records.</div>
                            </td>
                        </tr>
                    ) : timeLogs.length === 0 ? (
                        <tr>
                            <td colSpan={11} style={{ textAlign: "center", padding: "40px 20px", color: "#64748b" }}>
                                <div style={{ fontSize: "24px", marginBottom: "10px" }}><i className="fa fa-folder-open-o"></i></div>
                                <div style={{ fontWeight: 600, fontSize: "15px" }}>No Time Logs Found</div>
                                <div style={{ fontSize: "13px", color: "#94a3b8", marginTop: "4px" }}>There are no time logs available.</div>
                            </td>
                        </tr>
                    ) : timeLogs.map((item) => (
                        <tr key={item.id} className="wf-table-row">
                            <td>
                                <span className="wf-period-month">{getMonthName(item.month)}</span>
                                <span className="wf-period-year">{item.year}</span>
                            </td>
                            <td>
                                <button
                                    type="button"
                                    className="wf-period-btn"
                                    onClick={() => handleShowHide(item)}
                                >
                                    <span>{getMonthlyPeriod(item)}</span>
                                </button>
                            </td>
                            <td>
                                <button
                                    type="button"
                                    className="wf-metric-btn"
                                    onClick={() => handleShowHide(item)}
                                >
                                    <span className="wf-metric-primary">
                                        {formatTotalHours(item?.workingHrs)}
                                    </span>
                                    <span className="wf-metric-secondary">
                                        {getTotalDays(item.workingHrs)}{" "}
                                        {getTotalDays(item.workingHrs) > 1 ? "Days" : "Day"}
                                    </span>
                                </button>
                            </td>
                            <td>
                                {item.docList && item.docList.length > 0 ? (
                                    <ul className="wf-doc-list">
                                        {item.docList.map((doc, idx) => (
                                            <li key={idx} className="wf-doc-row">
                                                <button
                                                    type="button"
                                                    className="wf-doc-link"
                                                    onClick={() => handleDownloadFile(doc)}
                                                    title={doc.documentName}
                                                >
                                                    {doc.documentName.length > 15
                                                        ? doc.documentName.substring(0, 15) + "..."
                                                        : doc.documentName}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <span style={{ color: "#94a3b8" }}>—</span>
                                )}
                            </td>
                            <td>
                                {getInvoiceStatus(item)}
                            </td>
                            <td>
                                {(() => {
                                    const { rate, effectiveDate } = getApplicableRateDetails(item);
                                    return (
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                                            <div style={{
                                                fontSize: "13.5px",
                                                fontWeight: 600,
                                                color: "#0f172a",
                                                display: "inline-flex",
                                                alignItems: "center"
                                            }}>
                                                ${parseFloat(rate || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                <span style={{ color: "#64748b", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", marginLeft: "4px" }}>/ hr</span>
                                            </div>
                                            {effectiveDate && (
                                                <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                                                    <span style={{ fontSize: "11px", fontWeight: 600, color: "#64748b" }}>Eff:</span>
                                                    
                                                    <span style={{
                                                        fontSize: "12px",
                                                        fontWeight: 600,
                                                        color: "#475569"
                                                    }}>
                                                        <Moment format="MMM Do YYYY">{effectiveDate}</Moment>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </td>
                            <td>
                                <div style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    fontSize: "13.5px",
                                    fontWeight: 600,
                                    color: "#1e293b",
                                    background: "#f1f5f9",
                                    border: "1px solid #e2e8f0",
                                    borderRadius: "0",
                                    padding: "4px 8px"
                                }}>
                                    ${(() => {
                                        const { rate } = getApplicableRateDetails(item);
                                        return Number(parseFloat(getTotalHours(item?.workingHrs) * rate).toFixed(2)).toLocaleString("en-US", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        });
                                    })()}
                                </div>
                            </td>
                            <td>
                                {getRecruiterInvoice(item)}
                            </td>
                            <td>
                                <button
                                    type="button"
                                    className="wf-notes-btn"
                                    onClick={() => handleNoteShowHide(item)}
                                >
                                    View/Add
                                    <span className="wf-notes-badge">
                                        {item?.allComments.filter(x => x.commentType === notesType).length}
                                    </span>
                                </button>
                            </td>
                            <td>
                                <div style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    fontSize: "13.5px",
                                    fontWeight: 600,
                                    color: "#15803d",
                                    background: "#f0fdf4",
                                    border: "1px solid #bbf7d0",
                                    borderRadius: "0",
                                    padding: "4px 8px"
                                }}>
                                    ${parseFloat(getFinalAmout(item) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </td>
                            <td>
                                {getPaymentStatus(item)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>



        <InvoiceReview
            invRevShowHide={invRevShowHide}
            handleInvRevShowHide={handleInvRevShowHide}
            candidateObj={candidate}
            selectedObj={timeLogObj}
            invType={invType}
            timeLogInvoices={timeLogInvoices}
            getInvoiceAmount={getInvoiceAmount}
            entType={entType}
        ></InvoiceReview>

        {noteShowHide && <AddEditNotes
            noteShowHide={noteShowHide}
            handleNoteShowHide={handleNoteShowHide}
            notesType={notesType}
            candidateObj={candidate}
            timeLogObj={timeLogObj}
        ></AddEditNotes>}


        <CandidatePay
            payShowHide={payShowHide}
            handlePayShowHide={handlePayShowHide}
            candidateObj={candidate}
            selectedObj={timeLogObj}
            invType={invType}
            timeLogInvoices={timeLogInvoices}
            getInvoiceAmount={getInvoiceAmount}
            entType={entType}
            wfTask={wfTask}
        ></CandidatePay>

        {
            timeLogShowHide &&
            <AddNewTimeLog
                showHide={timeLogShowHide}
                handleShowHide={handleShowHide}
                selectedObj={timeLogObj}
                allTimeLogs={timeLogs}
                candidateObj={candidate}
                timeLogInvoices={timeLogInvoices}
                projectStartDate={projectStDt}
            ></AddNewTimeLog>
        }

        <style>{`
                /* Modern Table Style matching WorkflowUser */
                .wf-table {
                  width: 100% !important;
                  border-collapse: separate !important;
                  border-spacing: 0 2px !important;
                }

                .wf-table-scroll {
                  overflow: auto !important;
                  scrollbar-width: thin;
                  scrollbar-color: #94a3b8 #f1f5f9;
                  border-radius: 0;
                  border: 1px solid #cbd5e1 !important;
                  background-color: #ffffff;
                }

                .wf-table-scroll::-webkit-scrollbar {
                  width: 8px;
                  height: 8px;
                }

                .wf-table-scroll::-webkit-scrollbar-track {
                  background: #f1f5f9;
                  border-radius: 0;
                }

                .wf-table-scroll::-webkit-scrollbar-thumb {
                  background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
                  border-radius: 0;
                  border: 2px solid #f1f5f9;
                }

                .wf-table-scroll::-webkit-scrollbar-thumb:hover {
                  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
                }

                .wf-thead {
                  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
                  position: sticky !important;
                  top: 0 !important;
                  z-index: 2 !important;
                }

                .wf-thead th {
                  font-family: "Open Sans", sans-serif !important;
                  font-size: 12px !important;
                  font-weight: 700 !important;
                  color: #000000 !important;
                  text-transform: uppercase !important;
                  letter-spacing: 0.6px !important;
                  padding: 13px 16px !important;
                  border-bottom: 2px solid #e2e8f0 !important;
                  border-top: none !important;
                  white-space: nowrap !important;
                }

                .wf-table tbody tr:nth-of-type(odd),
                .wf-table.table-striped tbody tr:nth-of-type(odd) {
                  background-color: #ffffff !important;
                }

                .wf-table tbody tr:nth-of-type(even),
                .wf-table.table-striped tbody tr:nth-of-type(even) {
                  background-color: #f8fafc !important;
                }

                .wf-table-row {
                  cursor: pointer !important;
                  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
                }

                .wf-table-row:hover {
                  background: #f8fafc !important;
                  box-shadow: inset 3px 0 0 0 #171717 !important;
                }

                .wf-table-row:hover td {
                  color: #000000 !important;
                }

                .wf-table-row:active {
                  transform: scaleY(0.98) !important;
                }

                .wf-table td {
                  padding: 13px 16px !important;
                  font-family: "Open Sans", sans-serif !important;
                  font-size: 14px !important;
                  font-weight: 400 !important;
                  color: #1e293b !important;
                  border-bottom: 1px solid #f1f5f9 !important;
                  vertical-align: top !important;
                  transition: color 0.15s ease !important;
                }

                .wf-table tbody tr:last-child td {
                  border-bottom: none !important;
                }

                .wf-thead-subtext {
                  display: block !important;
                  font-size: 9.5px !important;
                  font-weight: 700 !important;
                  letter-spacing: 0.4px !important;
                  color: #000000 !important;
                  text-transform: none !important;
                  margin-top: 4px !important;
                }

                /* Premium Stats Header Row styling */
                                .wf-stats-row {
                  display: grid;
                  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                  gap: 12px;
                  margin-bottom: 16px;
                }

                @media (max-width: 992px) {
                  .wf-stats-row {
                    grid-template-columns: repeat(2, 1fr);
                  }
                }

                @media (max-width: 576px) {
                  .wf-stats-row {
                    grid-template-columns: 1fr;
                  }
                }

                .wf-stat-card {
                  background: linear-gradient(180deg, #ffffff 0%, #fcfdfe 100%);
                  border: 1px solid rgba(226, 232, 240, 0.9);
                  border-radius: 0;
                  padding: 12px 14px;
                  box-shadow: none !important;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  gap: 12px;
                  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
                  position: relative;
                  overflow: hidden;
                }

                .wf-stat-card:hover {
                  transform: translateY(-2px);
                  box-shadow: none !important;
                  border-color: #a3a3a3;
                }

                .wf-stat-card::before {
                  content: "";
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  height: 3px;
                  background: #171717;
                  opacity: 0;
                  transition: opacity 0.25s ease;
                }

                .wf-stat-card:hover::before {
                  opacity: 1;
                }

                .wf-stat-text {
                  display: flex;
                  flex-direction: column;
                  min-width: 0;
                }

                .wf-stat-label {
                  font-size: 10.5px;
                  font-weight: 600;
                  text-transform: uppercase;
                  color: #64748b;
                  letter-spacing: 0.08em;
                  line-height: 1.2;
                  margin: 0 0 2px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .wf-stat-icon-wrap {
                  width: 34px;
                  height: 34px;
                  flex: 0 0 auto;
                  border-radius: 0;
                  background: #f5f5f5;
                  color: #171717;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 14px;
                  border: 1px solid #d4d4d4;
                }

                .wf-stat-value {
                  font-size: 20px;
                  font-weight: 600;
                  color: #0f172a;
                  font-variant-numeric: tabular-nums;
                  letter-spacing: -0.02em;
                  line-height: 1.15;
                }

                /* Premium Controls Card */
                .wf-controls-card {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  gap: 16px;
                  background: transparent !important;
                  border: none !important;
                  border-bottom: 1px solid #e2e8f0 !important;
                  border-radius: 0 !important;
                  padding: 0 0 16px 0 !important;
                  margin-bottom: 20px !important;
                  box-shadow: none !important;
                }

                @media (max-width: 576px) {
                  .wf-controls-card {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 14px;
                    padding: 16px;
                  }
                }

                .wf-controls-left {
                  display: flex;
                  align-items: center;
                  gap: 16px;
                  flex-wrap: wrap;
                }

                @media (max-width: 576px) {
                  .wf-controls-left {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 12px;
                  }
                }

                /* Select wrapper with prepended icon */
                .wf-select-wrapper {
                  position: relative;
                  display: inline-flex;
                  align-items: center;
                }

                @media (max-width: 576px) {
                  .wf-select-wrapper {
                    width: 100%;
                  }
                }

                .wf-select-icon {
                  position: absolute;
                  left: 14px;
                  color: #64748b;
                  font-size: 14px;
                  pointer-events: none;
                  z-index: 2;
                }

                .wf-control-select {
                  height: auto;
                  min-height: 32px;
                  min-width: 150px;
                  border-radius: 0 !important;
                  border: 1px solid #cbd5e1 !important;
                  padding: 7px 36px 7px 36px !important;
                  font-family: "Open Sans", sans-serif !important;
                  font-size: 14px !important;
                  font-weight: 500 !important;
                  color: #1e293b !important;
                  background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 14px center !important;
                  appearance: none !important;
                  -webkit-appearance: none !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                  cursor: pointer;
                  outline: none !important;
                  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                }

                @media (max-width: 576px) {
                  .wf-control-select {
                    width: 100%;
                  }
                }

                .wf-control-select:hover {
                  border-color: #cbd5e1 !important;
                  background-color: #fafbfc !important;
                }

                .wf-control-select:focus {
                  border-color: #2563eb !important;
                  box-shadow: 0 0 0 3.5px rgba(37, 99, 235, 0.08) !important;
                  background-color: #ffffff !important;
                }

                 .wf-btn-add {
                   display: inline-flex;
                   align-items: center;
                   justify-content: center;
                   gap: 8px;
                   height: auto;
                   min-height: 32px;
                   padding: 7px 14px;
                   border-radius: 0;
                   border: 1px solid #cbd5e1;
                   background: #ffffff;
                   color: #1e293b;
                   font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                   font-size: 14px;
                   font-weight: 500;
                   cursor: pointer;
                   transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                   outline: none;
                   box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                 }

                 .wf-btn-add i {
                   font-size: 14px;
                   color: #64748b;
                   font-weight: 500;
                 }

                 .wf-btn-add:hover {
                   background: #f8fafc;
                   border-color: #94a3b8;
                   color: #0f172a;
                   transform: translateY(-1px);
                   box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                 }

                 .wf-btn-add:active {
                   transform: scale(0.97);
                 }

                           .wf-period-month {
                    display: block;
                    font-weight: 600;
                    color: #1e293b;
                    line-height: 1.2;
                  }

                  .wf-period-year {
                    display: block;
                    font-size: 11.5px;
                    font-weight: 600;
                    color: #94a3b8;
                    line-height: 1.2;
                  }

                  .wf-period-range {
                    display: flex;
                    flex-direction: column;
                    gap: 2px;
                    text-align: left;
                  }

                  .wf-period-range-line {
                    display: inline-flex;
                    align-items: baseline;
                    gap: 6px;
                    line-height: 1.25;
                    font-variant-numeric: tabular-nums;
                    white-space: nowrap;
                  }

                  .wf-period-range-tag {
                    font-size: 9.5px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.06em;
                    color: #94a3b8;
                    min-width: 26px;
                  }

                  .wf-period-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 7px 14px;
                    border-radius: 0;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    color: #1e293b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    outline: none;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                  }
                  .wf-period-btn:hover {
                    background: #f8fafc;
                    border-color: #94a3b8;
                    color: #0f172a;
                    transform: translateY(-1px);
                  }
                  .wf-period-btn:active {
                    transform: scale(0.97);
                  }
                  .wf-period-icon {
                    color: #64748b;
                    font-size: 12.5px;
                  }

                  .wf-metric-btn {
                    display: inline-flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 4px;
                    padding: 8px 14px;
                    border-radius: 0;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    color: #334155;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    outline: none;
                    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
                  }
                  .wf-metric-btn:hover {
                    background: #f8fafc;
                    border-color: #94a3b8;
                    color: #0f172a;
                    transform: translateY(-1px);
                  }
                  .wf-metric-btn:active {
                    transform: scale(0.97);
                  }

                .wf-btn-apply {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  height: auto;
                  min-height: 32px;
                  padding: 7px 14px;
                  border-radius: 0;
                  border: 1px solid #cbd5e1;
                  background: #ffffff;
                  color: #1e293b;
                  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                  font-size: 14px;
                  font-weight: 500;
                  cursor: pointer;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                  outline: none;
                  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                }

                .wf-btn-apply i {
                  font-size: 14px;
                  color: #64748b;
                  font-weight: 500;
                }

                .wf-btn-apply:hover {
                  background: #f8fafc;
                  border-color: #94a3b8;
                  color: #0f172a;
                  transform: translateY(-1px);
                  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                }

                .wf-btn-apply:active {
                  transform: scale(0.97);
                }

                .wf-btn-reset {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  height: auto;
                  min-height: 32px;
                  padding: 7px 14px;
                  border-radius: 0;
                  border: 1px solid #cbd5e1;
                  background: #ffffff;
                  color: #1e293b;
                  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                  font-size: 14px;
                  font-weight: 500;
                  cursor: pointer;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                  outline: none;
                  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                }

                .wf-btn-reset i {
                  font-size: 14px;
                  color: #64748b;
                }

                .wf-btn-reset:hover {
                  background: #f8fafc;
                  border-color: #94a3b8;
                  color: #1e293b;
                }

                 .wf-btn-reset:active {
                   transform: scale(0.97);
                 }

                 }
                 .wf-period-icon {
                   color: #2563eb;
                   color: #64748b;
                   font-size: 12.5px;
                 }

                 .wf-metric-btn {
                   display: inline-flex;
                   flex-direction: column;
                   align-items: flex-start;
                   gap: 4px;
                   padding: 8px 14px;
                   border-radius: 0;
                   background: #ffffff;
                   border: 1px solid #cbd5e1;
                   color: #334155;
                   cursor: pointer;
                   transition: all 0.2s ease;
                   outline: none;
                   box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
                 }
                  .wf-period-month {
                    display: block;
                    font-weight: 600;
                    color: #1e293b;
                    line-height: 1.2;
                  }

                  .wf-period-year {
                    display: block;
                    font-size: 11.5px;
                    font-weight: 600;
                    color: #94a3b8;
                    line-height: 1.2;
                  }

                  .wf-metric-btn:hover {
                    background: #f8fafc;
                    border-color: #94a3b8;
                    color: #0f172a;
                    transform: translateY(-1px);
                  }
                  .wf-metric-btn:active {
                    transform: scale(0.97);
                  }
                  .wf-metric-primary {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.15;
                    color: #1e293b;
                  }
                  .wf-metric-primary i {
                    color: #64748b;
                    font-size: 14px;
                  }
                  .wf-metric-secondary {
                    display: block;
                    color: #64748b;
                    font-size: 12px;
                    font-weight: 400;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    line-height: 1.2;
                  }

                 .wf-notes-btn {
                   display: inline-flex;
                   align-items: center;
                   justify-content: center;
                   gap: 8px;
                   border-radius: 0;
                   border: 1px solid #cbd5e1;
                   background: #ffffff;
                   color: #1e293b;
                   padding: 7px 14px;
                   font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                   font-size: 14px;
                   font-weight: 500;
                   cursor: pointer;
                   transition: all 0.2s ease;
                   outline: none;
                   box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                 }
                 .wf-notes-btn:hover {
                   background: #f8fafc;
                   border-color: #94a3b8;
                   color: #0f172a;
                   transform: translateY(-1px);
                 }
                 .wf-notes-btn:active {
                   transform: scale(0.97);
                 }
                 .wf-notes-badge {
                   min-width: 18px;
                   height: 18px;
                   border-radius: 0;
                   display: inline-flex;
                   align-items: center;
                   justify-content: center;
                   background: #f1f5f9;
                   color: #475569;
                   font-size: 10px;
                   font-weight: 600;
                   padding: 0 4px;
                   border: 1px solid #e2e8f0;
                   margin-left: 4px;
                 }

                 .wf-doc-list {
                   list-style: none;
                   margin: 0;
                   padding: 0;
                   display: flex;
                   flex-direction: column;
                   gap: 6px;
                 }
                 .wf-doc-row {
                   display: flex;
                   justify-content: space-between;
                   align-items: center;
                   gap: 8px;
                   padding: 6px 10px;
                   border: 1px solid #e2e8f0;
                   border-radius: 0;
                   background: #ffffff;
                   box-shadow: 0 2px 6px rgba(15, 23, 42, 0.015);
                   transition: all 0.2s ease;
                 }
                 .wf-doc-row:hover {
                   border-color: #cbd5e1;
                   background: #f8fafc;
                   transform: translateY(-0.5px);
                 }
                 .wf-doc-link {
                   border: none;
                   background: transparent;
                   color: #2563eb !important;
                   padding: 0;
                   font-family: "Open Sans", sans-serif !important;
                   font-size: 14px;
                   font-weight: 500;
                   text-align: left;
                   word-break: break-all;
                   outline: none;
                   cursor: pointer;
                   display: inline-flex;
                   align-items: center;
                   gap: 6px;
                   text-decoration: none;
                   transition: color 0.15s ease, text-decoration 0.15s ease;
                 }
                 .wf-doc-link:hover {
                   color: #1d4ed8 !important;
                   text-decoration: underline !important;
                 }
                 .wf-doc-link i {
                   color: #2563eb !important;
                 }

                  .wf-doc-row-delete {
                    border-color: #fecaca !important;
                    background: #fef2f2 !important;
                  }
                  .wf-doc-row-delete:hover {
                    border-color: #fca5a5 !important;
                    background: #fee2e2 !important;
                    transform: translateY(-0.5px) !important;
                  }
                  .wf-btn-delete-regenerate {
                    color: #dc2626 !important;
                  }
                  .wf-btn-delete-regenerate i {
                    color: #dc2626 !important;
                  }
                  .wf-doc-row-delete:hover .wf-btn-delete-regenerate,
                  .wf-doc-row-delete:hover .wf-btn-delete-regenerate i {
                    color: #b91c1c !important;
                  }

                 .wf-status-stack {
                   display: flex;
                   flex-direction: column;
                   align-items: flex-start;
                   gap: 6px;
                 }
                 .wf-status-pill {
                   display: inline-flex;
                   align-items: center;
                   gap: 6px;
                   min-height: 32px;
                   padding: 7px 14px;
                   border-radius: 0;
                   border: 1px solid #cbd5e1;
                   background: #ffffff;
                   color: #1e293b;
                   font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                   font-size: 14px;
                   font-weight: 500;
                   line-height: 1.2;
                   white-space: nowrap;
                   transition: all 0.2s ease;
                   box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                 }
                 .wf-status-pill:hover {
                   background: #f8fafc;
                   border-color: #94a3b8;
                   color: #0f172a;
                 }
                 .wf-status-pending {
                   color: #334155;
                   background-color: #ffffff;
                   border-color: #cbd5e1;
                 }
                 .wf-status-pending i {
                   color: #d97706;
                 }
                 .wf-status-pending:hover {
                   background-color: #f8fafc;
                   border-color: #94a3b8;
                   color: #0f172a;
                 }
                 .wf-status-approved {
                   color: #334155;
                   background-color: #ffffff;
                   border-color: #cbd5e1;
                 }
                 .wf-status-approved i {
                   color: #16a34a;
                 }
                 .wf-status-approved:hover {
                   background-color: #f8fafc;
                   border-color: #94a3b8;
                   color: #0f172a;
                 }
                 .wf-status-rejected {
                   color: #334155;
                   background-color: #ffffff;
                   border-color: #cbd5e1;
                 }
                 .wf-status-rejected i {
                   color: #dc2626;
                 }
                 .wf-status-rejected:hover {
                   background-color: #f8fafc;
                   border-color: #94a3b8;
                   color: #0f172a;
                 }
                 .wf-status-reviewed {
                   color: #334155;
                   background-color: #ffffff;
                   border-color: #cbd5e1;
                 }
                 .wf-status-reviewed i {
                   color: #2563eb;
                 }
                 .wf-status-reviewed:hover {
                   background-color: #f8fafc;
                   border-color: #94a3b8;
                   color: #0f172a;
                 }
                 .wf-status-date {
                   font-size: 11px;
                   color: #64748b;
                   line-height: 1.4;
                 }

                 /* Normalize button font weight */
                 .wf-period-btn,
                 .wf-metric-btn,
                 .wf-metric-primary,
                 .wf-notes-btn,
                 .wf-status-pill,
                 .wf-control-select {
                   font-family: "Open Sans", sans-serif !important;
                   font-size: 14px !important;
                   font-weight: 500 !important;
                   color: #1e293b !important;
                 }
                 .wf-metric-secondary {
                   font-family: "Open Sans", sans-serif !important;
                   font-size: 12px !important;
                   font-weight: 400 !important;
                 }

                .wf-btn-apply,
                .wf-btn-add {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  gap: 7px !important;
                  padding: 7px 14px !important;
                  min-height: 32px !important;
                  box-sizing: border-box !important;
                  border-radius: 0 !important;
                  font-family: "Open Sans", sans-serif !important;
                  font-size: 14px !important;
                  font-weight: 500 !important;
                  background: #2563eb !important;
                  border: 1px solid #2563eb !important;
                  color: #ffffff !important;
                  cursor: pointer !important;
                  outline: none !important;
                  box-shadow: 0 2px 5px rgba(37, 99, 235, 0.25) !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                }

                .wf-btn-apply i,
                .wf-btn-add i {
                  font-size: 14px !important;
                  color: #ffffff !important;
                }

                .wf-btn-apply:hover,
                .wf-btn-add:hover {
                  background: #1d4ed8 !important;
                  border-color: #1d4ed8 !important;
                  color: #ffffff !important;
                  transform: translateY(-1px) !important;
                  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.35) !important;
                }

                .wf-btn-apply:hover i,
                .wf-btn-add:hover i {
                  color: #ffffff !important;
                }

                .wf-btn-apply:active,
                .wf-btn-add:active {
                  transform: scale(0.97) !important;
                }

                .wf-btn-reset {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  gap: 7px !important;
                  padding: 7px 14px !important;
                  min-height: 32px !important;
                  box-sizing: border-box !important;
                  border-radius: 0 !important;
                  font-family: "Open Sans", sans-serif !important;
                  font-size: 14px !important;
                  font-weight: 500 !important;
                  background: #ffffff !important;
                  border: 1px solid #cbd5e1 !important;
                  color: #1e293b !important;
                  cursor: pointer !important;
                  outline: none !important;
                  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                }

                .wf-btn-reset i {
                  font-size: 14px !important;
                  color: #2563eb !important;
                }

                .wf-btn-reset:hover {
                  background: #eff6ff !important;
                  border-color: #93c5fd !important;
                  color: #1d4ed8 !important;
                  transform: translateY(-1px) !important;
                  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.12) !important;
                }

                .wf-btn-reset:hover i {
                  color: #1d4ed8 !important;
                }

                .wf-btn-reset:active {
                  transform: scale(0.97) !important;
                }

`}</style>

    </React.Fragment>
}
